import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";

import utils from "../../Utils";
import moment from 'moment';
import Constants from "../../Constants";

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: ComponentSet,
    mixins: [utils],
    data: {
        keyword: null
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        let _this = this
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData(function () {
            _this.keyword = _.get(_this, 'form.keyword', null) || null
        });
    },
    methods: {
        search(){
            if(this.keyword != '' && this.keyword != null){
                window.location.search = 'keyword='+this.keyword;
            }else{
                window.location.search = '';
            }
            // this.retrieveSiteContentData()
        },
        openAnswer(event){
            let target = event.currentTarget
            target.classList.toggle("open")
            target.closest('.faq_item').querySelector('.faq_a').classList.toggle("show")
        }
        
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        listData() {
            return _.get(this, 'contentData.list', []) || [];
        }
    }, // end of computed
}).$mount('#app');